export default __webpack_public_path__ + "static/media/food-icon.8278cf37.svg";